._gapBox_1hxsv_1 {
  position: absolute;
  background: rgba(17, 109, 255, 0.1); }
  ._gapBox_1hxsv_1._isResizing_1hxsv_4 > ._resizeHandle_1hxsv_4 {
    opacity: 0; }
  ._gapBox_1hxsv_1._isResizing_1hxsv_4, ._gapBox_1hxsv_1:has(._resizeHandle_1hxsv_4:hover) {
    background: rgba(17, 109, 255, 0.2);
    cursor: row-resize; }

._resizeHandle_1hxsv_4 {
  width: 36px;
  height: 14px;
  z-index: 2; }
  ._resizeHandle_1hxsv_4::after {
    display: block;
    content: '';
    width: 18px;
    height: 3px;
    border-radius: 30px;
    background: #116dff;
    border: 1px solid #ffffff; }

._heightIndication_1hxsv_23 {
  width: 30px;
  height: 14px;
  border-radius: 2px;
  background-color: #116dff;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(15px, -50%); }
  ._heightIndication_1hxsv_23 span {
    font-size: 10px;
    font-weight: 600;
    font-family: var(--wbu-font-stack);
    color: #ffffff;
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%); }

._gapBox_1hxsv_1,
._resizeHandle_1hxsv_4 {
  display: flex;
  align-items: center;
  justify-content: center; }
